<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h1 class="mb-5">Prašymas dėl juridinio fakto</h1>
    <v-card class="pa-5">
      <template>
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(tipas, index) in filterTipasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkTipas(toggle, active, tipas)"
                  height="100%"
                  :elevation="active ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="tipas.icon"
                    :active="active"
                    type="prasymas"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ tipas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>
      <template v-if="isTipas">
        <v-item-group class="mb-4">
          <v-row align="stretch">
            <v-col
              v-for="(veiksmas, index) in filterVeiksmasList"
              :key="index"
              cols="12"
              md="2"
            >
              <v-item v-slot="{ active, toggle }">
                <v-card
                  class="mx-auto"
                  @click="checkVeiksmas(toggle, active, veiksmas)"
                  height="100%"
                  :elevation="active && isVeiksmas ? '5' : '0'"
                >
                  <el-tipas-icon
                    :icon="veiksmas.icon"
                    :active="active && isVeiksmas"
                    type="prasymas"
                  >
                  </el-tipas-icon>
                  <v-card-text>
                    <div :color="active ? 'primary' : 'disabled'">
                      {{ veiksmas.title }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>
      </template>

      <template v-if="isVeiksmasContinued || isVeiksmasNew">
        <div class="dataContainer">
          <v-row align="baseline" class="mb-4">
            <template v-if="prasymasNerastas">
              <v-col cols="6" md="12">
                <v-alert dense outlined type="error">
                  {{ prasymasNerastasMsg }}
                </v-alert>
              </v-col>
            </template>

            <template v-if="isVeiksmasContinued">
              <v-col cols="12" md="8">
                <el-text-field
                  label="Dokumento numeris"
                  tooltip="Prašymas. Kūrimas. Dokumento numeris"
                  v-model="searchKodas"
                />
              </v-col>
            </template>

            <v-col cols="12" md="12" v-if="isKodas && tipasKitas">
              <v-alert dense outlined type="warning">
                Rastas dokumentas:
                <h4 :class="tipasKitas">{{ sutartisTitle }}</h4>
              </v-alert>
            </v-col>

            <v-col cols="12" md="8">
              <el-button
                v-if="isVeiksmasContinued"
                primary
                @click.native="checkKodas()"
                :loading="loadingSearch"
                :disabled="!canSubmit"
                >{{ sutartisButtonText }}</el-button
              >
              <el-button
                v-if="isVeiksmasNew"
                primary
                @click.native="sukurtiPrasymas()"
                :loading="loadingSearch"
                :disabled="!canSubmit"
                >{{ sutartisButtonText }}</el-button
              >
            </v-col>
          </v-row>
        </div>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import NtrPaslaugosMap from '../ntrpaslaugos/NtrPaslaugosMap'

export default {
  name: 'Sutartis',
  mixins: [userRole],
  data() {
    return {
      pageloading: true,
      vykdomasis: null,
      veiksmas: null,
      tipas: null,
      prasymas: null,
      searchKodas: null,
      tipasKitas: null,
      prasymasNerastas: false,
      loadingSearch: false,
      prasymasNerastasMsg: null,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'appSavitarna']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    tipasList() {
      return [
        {
          key: 'bendra',
          type: 'bendra',
          title: 'Bendroji jungtinė sutuoktinių nuosavybė',
          icon: 'mdi-account-multiple-check-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'seima',
          type: 'seima',
          title: 'Šeimos turtas',
          icon: 'mdi-account-cash-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'pirmenybe',
          type: 'pirmenybe',
          title: 'Pirmenybės teisės atsisakymas',
          icon: 'mdi-account-cash-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'nuoma',
          type: 'nuoma',
          title: 'Nuoma',
          icon: 'mdi-account-cash-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
          hide: !this.isLocal,
        },
        {
          key: 'panauda',
          type: 'panauda',
          title: 'Panauda',
          icon: 'mdi-account-cash-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
          hide: !this.isLocal,
        },
        {
          key: 'subnuomos',
          type: 'subnuomos',
          title: 'Subnuoma',
          icon: 'mdi-account-cash-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
          hide: !this.isLocal,
        },
        {
          key: 'preliminari',
          type: 'preliminari',
          title: 'Preliminari',
          icon: 'mdi-account-cash-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
          hide: !this.isLocal,
        },
      ]
    },
    veiksmasList() {
      return [
        {
          key: 'iregistravimas',
          type: 'seima new',
          title: 'Įregistravimas',
          icon: 'mdi-file-document-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'perkelimas',
          type: 'seima new',
          title: 'Perkėlimas',
          icon: 'mdi-file-document-multiple-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'isregistravimas',
          type: 'seima new',
          title: 'Išregistravimas',
          icon: 'mdi-file-remove-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'iregistravimas',
          type: 'bendra new',
          title: 'Įregistravimas',
          icon: 'mdi-file-export-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'iregistravimas',
          type: 'pirmenybe new',
          title: 'Įregistravimas',
          icon: 'mdi-file-document-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'isregistravimas',
          type: 'pirmenybe new',
          title: 'Išregistravimas',
          icon: 'mdi-file-remove-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'iregistravimas',
          type: 'nuoma new',
          title: 'Įregistravimas',
          icon: 'mdi-file-export-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'iregistravimas',
          type: 'panauda new',
          title: 'Įregistravimas',
          icon: 'mdi-file-export-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'iregistravimas',
          type: 'subnuomos new',
          title: 'Įregistravimas',
          icon: 'mdi-file-export-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
        {
          key: 'iregistravimas',
          type: 'preliminari new',
          title: 'Įregistravimas',
          icon: 'mdi-file-export-outline',
          role: ['DT_notaras', 'DT_notaro_padejejas', 'DT_notaro_atstovas'],
        },
      ]
    },
    filterTipasList() {
      return this.tipasList.filter(tipas => {
        return this.roleOr(tipas.role) && !tipas.hide
      })
    },
    filterVeiksmasList() {
      return this.veiksmasList.filter(veiksmas => {
        return (
          this.roleOr(veiksmas.role) && veiksmas.type.includes(this.tipas.type)
        )
      })
    },
    isVeiksmas() {
      return this.veiksmas !== null
    },
    isTipas() {
      return this.tipas !== null
    },
    isVeiksmasNew() {
      return this.combineType.includes('new')
    },
    isVeiksmasContinued() {
      return this.combineType.includes('continued')
    },
    combineType() {
      let type = ''
      this.tipas && (type += this.tipas.type)
      this.veiksmas && (type += ' ' + this.veiksmas.type)
      return type
    },
    isKodas() {
      return this.prasymas && this.prasymas.pra_id !== null
    },
    sutartisButtonText() {
      return 'Pildyti prašymą'
    },
    sutartisTitle() {
      return NtrPaslaugosMap.getPrasymasTipas(this.prasymasTipas).title
    },
    prasymasTipas() {
      return (
        (this.tipas ? this.tipas.key : '') +
        '-' +
        (this.veiksmas ? this.veiksmas.key : '')
      )
    },
    searchTipas() {
      return this.tipasList.filter(tipas => {
        return this.prasymas && this.prasymas.pra_tipas.includes(tipas.key)
      })[0]
    },
    dokumentasNerastasMsg() {
      return 'Dokumentas nerastas'
    },
    canSubmit() {
      return this.searchKodas || this.isVeiksmasNew
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = false
    },
    checkVeiksmas(toggle, active, veiksmas) {
      this.veiksmas = veiksmas
      this.vykdomasis = null
      this.prasymas = null
      this.prasymasNerastas = false
      if (!active) {
        toggle()
      }
    },
    checkTipas(toggle, active, tipas) {
      this.tipas = tipas
      this.tipasKitas = null
      this.prasymasNerastas = false
      this.vykdomasis = null
      this.veiksmas = null
      this.prasymas = null
      if (!active) {
        toggle()
      }
    },
    checkKodas() {
      this.loadingSearch = true
      this.prasymas = null
      this.prasymasNerastas = false
      this.tipasKitas = null

      const data = {
        pra_tipas: this.prasymasTipas,
        pra_id: this.searchKodas,
      }
      this.$axios
        .post(`prasymas/search`, data)
        .then(res => {
          this.prasymas = res.data.prasymas

          if (!this.prasymas.pra_tipas.includes(this.tipas.key)) {
            if (this.searchTipas) {
              this.tipas = this.searchTipas
              this.tipasKitas = 'tipasKitas'
            } else {
              this.prasymasNerastas = true
              this.prasymasNerastasMsg = this.dokumentasNerastasMsg
            }
            this.loadingSearch = false
          } else {
            this.sukurtiPrasymas()
          }
        })
        .catch(err => {
          this.prasymasNerastas = true
          this.prasymasNerastasMsg =
            err.response.data.message ?? this.dokumentasNerastasMsg
          this.loadingSearch = false
          // window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {})
    },
    sukurtiPrasymas() {
      this.loadingSearch = true
      const data = {
        pra_tipas: this.prasymasTipas,
        pra_id: this.prasymas ? this.prasymas.pra_id : null,
      }
      this.$axios
        .post(`ntrpaslaugos/prasymas`, data)
        .then(res => {
          this.$store.dispatch('prasymasID', res.data.prasymas.pra_id)
          this.$store.dispatch('prasymasTipas', this.prasymasTipas)
          this.$router.push({
            name: 'regPrasymasDuomenys',
            params: {
              prasymasID: this.prasymasID,
            },
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loadingSearch = false
        })
        .finally(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.tipasKitas {
  color: #686868;
}
.dataContainer {
  max-width: 800px;
}
</style>
